import React from "react";
import "../../style/_home.scss";
import GrayCircle from "./homecomponent/grayCircle";

const Feature = (props) => {


const name1 = "Concrete Repair";
  const name2 = "Plaster Restoration";
  const name3 = "Water Sealing";
  const name4 = "Roof Installation";
  const name5 = "Exterior Painting";


  const landname1="Pool Enhancement & Upgrade";
  const landname2="Stone Pathways & Lush Gardens";
  const landname3="Shoreline protection";
  const landname4="Dock and deck";
  return (
    <div id="feature" className="featureBanner">
      <img
        className="blueprintleft"
        src="../../../images/home/featureBlueprintleft.png"
        alt=""
      />
      <img
        className="blueprintright"
        src="../../../images/home/featureBlueprintright.png"
        alt=""
      />
      <div className="featureHeadingBox">
        <div className="gradient-horiz-line mx-auto"></div>
        <p className="top-heading mx-auto text-center mt-4">FEATURES</p>
        <p className="main-gradient-heading">
          Bots that helps you in Construction
          <br />
        </p>
        <span className="sub-heading mx-auto">through Chat & voice agent </span>
      </div>

      <div className="featureContentBox">
        <div className="renovationBox">
            <div className="renovationBoxContent">
            <p className="reno-gradient-heading">Renovation</p>
          <p style={{width:"700px"}} className="para-text my-3 text-white ">     
          With every subtle touch and modification, we are upgrading your space creating a masterpiece of your desire.</p>
          <div className="circleContainer">
 <GrayCircle renovationName={name1}/>
 <GrayCircle renovationName={name2}/>
 <GrayCircle renovationName={name3}/>
 <GrayCircle renovationName={name4} className="ms-4"/>
 <GrayCircle renovationName={name5}/>
          </div>

          
            </div>
         
        </div>
        <div className="constructionBox ">

        <div className="renovationBoxContent">
            <p className="reno-gradient-heading">construction from scratch</p>
          <p style={{width:"700px"}} className="para-text my-3 text-white ">     
          Experience the fusion of construction and innovation in a way that will leave you spellbound.</p>
          <div className="circleContainer">
 <GrayCircle renovationName={landname1}/>
 <GrayCircle renovationName={landname2}/>
 <GrayCircle renovationName={landname3}/>
 <GrayCircle renovationName={landname4}/>

          </div>

          
            </div>
     
        </div>
      </div>
    </div>
  );
};

export default Feature;
